import * as React from 'react';

export interface UseHighlight {
  current: number;
  next: () => void;
  prev: () => void;
  select: () => void;
  reset: () => void;
}

export function useHighlight(items: { action: () => void }[] | undefined): UseHighlight {
  const [highlightedCurrent, setHighlightedCurrent] = React.useState(-1);
  const rl = items?.length || 0;
  const nextHighlighted = rl - 1 === highlightedCurrent ? -1 : highlightedCurrent + 1;
  const prevHighlighted = highlightedCurrent === -1 ? rl - 1 : highlightedCurrent - 1;

  return {
    current: highlightedCurrent,
    next: () => {
      if (rl === 0) return;
      setHighlightedCurrent(nextHighlighted);
    },
    prev: () => {
      if (rl === 0) return;
      setHighlightedCurrent(prevHighlighted);
    },
    select: () => {
      if (highlightedCurrent < 0 || !rl) return;
      const item = items?.[highlightedCurrent];
      if (item) item.action();
    },
    reset: () => {
      setHighlightedCurrent(-1);
    },
  };
}
